export enum ADDON_TYPE {
	BACKTOP = 'backtop',
	VIEWPORT = 'viewport',
	GLOBAL_LOADING = 'loading'
}

const backtopUIAddon: LAYOUT.IGridItem = {
	name: ADDON_TYPE.BACKTOP,
	isEnabled: true,
	component: 'BacktopUIAddon',
	useShadowRoot: true,
	styles: {
		style: {}
	},
	listeners: {}
};

const viewportUIAddon: LAYOUT.IGridItem = {
	name: ADDON_TYPE.VIEWPORT,
	isEnabled: true,
	component: 'Viewport',
	styles: {
		style: {
			paddingTop: '12px'
		}
	},
	listeners: {}
};

const globalLoadingUIAddon: LAYOUT.IGridItem = {
	name: ADDON_TYPE.GLOBAL_LOADING,
	isEnabled: true,
	component: '',
	styles: {
		style: {}
	},
	listeners: {}
};

export const ADDONS_MAP: Common.IMap<LAYOUT.IGridItem> = {
	[ADDON_TYPE.BACKTOP]: backtopUIAddon,
	[ADDON_TYPE.VIEWPORT]: viewportUIAddon,
	[ADDON_TYPE.GLOBAL_LOADING]: globalLoadingUIAddon
};
